<template>
  <el-select
    :value="declutterReason"
    :disabled="disabled"
    size="small"
    style="width: 100%;"
    value-key="id"
    @change="onDeclutterReasonChange"
  >
    <el-option
      v-for="reason in declutterReasons"
      :key="reason"
      :value="reason"
      :label="reason"
    />
  </el-select>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    declutterReason: {
      type: String,
      default() {
        return 'lejárt szavidő';
      },
      required: false,
    },
  },
  data() {
    return {
      price: 0,
      declutterReasons: ['lejárt szavidő', 'minőségi értékvesztés', 'sérült csomagolás', 'sérült termék', 'elemi kár'],
    };
  },
  watch: {
    unitPrice(price) {
      this.price = price;
    },
  },
  methods: {
    onDeclutterReasonChange(reason) {
      this.$emit('change', reason);
    },
  },
};
</script>
